import { render, staticRenderFns } from "./alertbar.vue?vue&type=template&id=f2e32daa&scoped=true&"
import script from "./alertbar.vue?vue&type=script&lang=js&"
export * from "./alertbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e32daa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2489941515/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2e32daa')) {
      api.createRecord('f2e32daa', component.options)
    } else {
      api.reload('f2e32daa', component.options)
    }
    module.hot.accept("./alertbar.vue?vue&type=template&id=f2e32daa&scoped=true&", function () {
      api.rerender('f2e32daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/alertbar.vue"
export default component.exports